import { customerv6Url } from '../api-urls';

export function createAcceptPrivacyPolicyAgreementRequest({ customerId, customerToken }) {
  return {
    url: `${customerv6Url}/${customerId}/actions/privacy-policy-agreement`,
    timeout: 2500,
    method: 'POST',
    headers: {
      'access-token': customerToken
    }
  };
}
